module.exports = __webpack_public_path__ + "static/img/7.f67663d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/7.png
// module id = izUD
// module chunks = 0